import { PersonAddOutlined } from '@mui/icons-material';
import { IconButton, Typography } from '@mui/material';
import { Avatar } from '@revenuewell/ui-icons';
import moment from 'moment';
import { FC } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { useEventBus } from '../../../../../../hooks/use-event-bus';
import { usePatientProfile } from '../../../../../../hooks/use-patient-profile';
import { ContactSearchByNumber } from '../../../../../../services/api-client/contact-api';
import { usePatientProfileWidget } from '../../hooks/use-patient-profile-widget';
import { Description, Header, Profile, ProfileName, Profiles, ProfilesSelector } from './profile-selector.styles';

export const ProfileSelectorView: FC = () => {
  const { publish } = useEventBus();
  const { locationId, networkId } = usePatientProfile();
  const { contactsByPhone } = usePatientProfileWidget();

  const renderResponsibleParty = (contact: ContactSearchByNumber) => {
    return contact.isResponsibleParty && <span> (RP)</span>;
  };

  const renderAge = (contact: ContactSearchByNumber) => {
    const hasDateOfBirth = contact.dateOfBirth && contact.dateOfBirth.length > 0;
    return hasDateOfBirth && <span>, {moment().diff(contact.dateOfBirth, 'years', false)}</span>;
  };

  return (
    <ProfilesSelector>
      {contactsByPhone?.length === 0 && (
        <Description color={'secondary'} variant={'body2'}>
          Sorry no matching patients found
        </Description>
      )}
      {contactsByPhone?.length > 0 && (
        <>
          <Header variant={'h6'} color={'primary'}>
            Select A Profile
          </Header>
          <Description color={'secondary'} variant={'body1'}>
            Our system has matched this number to multiple profiles. Please select the one you’d like to see.
          </Description>
          <Scrollbars autoHide style={{ flexGrow: 1 }}>
            <Profiles>
              {contactsByPhone.map((contact) => (
                <Profile
                  key={contact.id}
                  onClick={() => {
                    publish({
                      messageType: 'patientProfile',
                      data: {
                        patientId: contact.id,
                        locationId: contact.networkId == networkId ? contact.locationId : locationId
                      }
                    });
                  }}
                >
                  <Avatar size="l" />
                  <ProfileName>
                    <Typography variant={'body1'}>
                      {contact.firstName} {contact.lastName}
                      {renderResponsibleParty(contact)}
                      {renderAge(contact)}
                    </Typography>
                    {networkId !== contact.networkId && (
                      <IconButton>
                        <PersonAddOutlined style={{ color: 'rgb(76, 175, 80)' }} />
                      </IconButton>
                    )}
                  </ProfileName>
                </Profile>
              ))}
            </Profiles>
          </Scrollbars>
        </>
      )}
    </ProfilesSelector>
  );
};
